import React from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollTop";
import expoData from "../utils/expoData";
import SEO from "../components/SEO";
import WhatsAppMsg from "../components/WhatsApp";
import { Helmet } from "react-helmet";

const Media = () => {
  // Create the image gallery node for JSON‑LD
  const imageGallery = {
    "@type": "ItemList",
    name: "Media Image Gallery",
    itemListElement: expoData.flatMap((expo, expoIndex) =>
      expo.images.map((image, imageIndex) => ({
        "@type": "ListItem",
        position: expoIndex * expo.images.length + imageIndex + 1,
        item: {
          "@type": "ImageObject",
          url: image.src,
          caption: image.alt,
        },
      }))
    ),
  };

  return (
    <>
      <div className="bg-gray-900">
        <SEO
          title="Explore Media Highlights & Achievements | Coltec Media"
          description="Discover Coltec's journey of innovation through media coverage, awards, and events. Showcasing excellence in interactive flat panels and education technology solutions."
          keywords="Coltec Media, Interactive Flat Panels, Smart Displays for Education, Corporate Collaboration Technology, Education Technology Solutions, Interactive Touchscreen Displays, Digital Whiteboards, Smart Classroom Technology, Awards and Recognition, Media Coverage, Technology Events, Innovation Highlights, Corporate Media Showcase"
          ogTitle="Media Highlights & Awards | Coltec Global"
          ogDescription="Explore Coltec's moments of excellence in media—highlighting innovation in interactive flat panels and education technology for schools and businesses."
          ogImage="https://content.qeeb.in/coltec/media/media-banner-image.webp"
          ogUrl="https://coltec-global.com/media"
          canonicalUrl="https://coltec-global.com/media"
          ogImageAlt="Coltec Media Highlights and Innovation Showcase"
          ogSiteName="Coltec Global"
          ogType="website"
          twitterSite="https://x.com/ColtecGlobal" // Twitter username associated with the site
          twitterTitle="Explore Media Highlights & Achievements | Coltec Media"
          twitterDescription="Discover Coltec's journey of innovation through media coverage, awards, and events. Showcasing excellence in interactive flat panels and education technology solutions."
          twitterImage="https://content.qeeb.in/coltec/media/media-banner-image.webp"
          twitterCard="summary" // Using a large image card for enhanced visual display
          geoRegion="IN"
        />
        {/* JSON‑LD Structured Data with Publisher & Address Details */}
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(
              {
                "@context": "https://schema.org",
                "@graph": [
                  // Organization details
                  {
                    "@type": "Organization",
                    "@id": "https://coltec-global.com/#organization",
                    name: "COLTEC Global",
                    aggregateRating: {
                      "@type": "AggregateRating",
                      ratingValue: "4.8",
                      reviewCount: "350",
                    },
                    description:
                      "COLTEC Global is a leading manufacturer of Visual Interactive Display Technology, delivering innovative solutions for Education, Corporate, and Retail applications.",
                    url: "https://coltec-global.com",
                    logo: {
                      "@type": "ImageObject",
                      url: "https://content.qeeb.in/coltec/coltec-logo-black.svg",
                    },
                    address: [
                      {
                        "@type": "PostalAddress",
                        streetAddress:
                          "37, Survey No 75/A, Gagan Pahad Village, Raghavendra Nagar",
                        addressLocality: "Hyderabad",
                        addressRegion: "Telangana",
                        postalCode: "500030",
                        addressCountry: "IN",
                      },
                      {
                        "@type": "PostalAddress",
                        streetAddress:
                          "COLTEC GLOBAL #41-14-8/2, Opp Mouli Towers, Near Jyothi Convention Hall,Benz circle",
                        addressLocality: "Vijayawada",
                        addressRegion: "Andhra Pradesh",
                        postalCode: "520 010",
                        addressCountry: "IN",
                      },
                    ],
                    sameAs: [
                      "https://www.facebook.com/profile.php?id=61570213181020",
                      "https://x.com/ColtecGlobal",
                      "https://www.linkedin.com/company/coltec-global/",
                      "https://www.youtube.com/@coltecglobal5339",
                      "https://www.google.com/maps/place/COLTEC+GLOBAL+INDIA/@17.3297791,78.4381149,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcbbd8bb97fefcd:0x2536a4697f2f1423!8m2!3d17.3297791!4d78.4406898!16s%2Fg%2F11w1dth9rd?entry=ttu&g_ep=EgoyMDI1MDIyNi4xIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D",
                    ],
                    email: "sales@coltec-global.com",
                    contactPoint: [
                      {
                        "@type": "ContactPoint",
                        telephone: "+91 1800 309 8822",
                        contactType: "customer support",
                      },
                    ],
                  },
                  // WebSite details
                  {
                    "@type": "WebSite",
                    "@id": "https://coltec-global.com/#website",
                    url: "https://coltec-global.com",
                    name: "COLTEC Global",
                    publisher: {
                      "@id": "https://coltec-global.com/#organization",
                    },
                    potentialAction: {
                      "@type": "SearchAction",
                      target:
                        "https://coltec-global.com/?s={search_term_string}",
                      "query-input": "required name=search_term_string",
                    },
                    inLanguage: "en",
                  },
                  {
                    "@type": "WebPage",
                    name: "Explore Media Highlights & Achievements - Coltec Media",
                    url: "https://coltec-global.com/media",
                    description:
                      "Discover Coltec's journey of innovation through media coverage, awards, and events. Showcasing excellence in interactive flat panels and education technology solutions.",
                    image: {
                      "@type": "ImageObject",
                      url: "https://content.qeeb.in/coltec/coltec-logo-black.svg",
                    },
                  },
                  // Breadcrumb for Rise Series page
                  {
                    "@type": "BreadcrumbList",
                    itemListElement: [
                      {
                        "@type": "ListItem",
                        position: 1,
                        name: "Home",
                        item: "https://coltec-global.com",
                      },
                      {
                        "@type": "ListItem",
                        position: 2,
                        name: "Explore Media Highlights & Achievements - Coltec Media",
                        item: "https://coltec-global.com/media",
                      },
                    ],
                  },
                  {
                    "@type": "LocalBusiness",
                    "@id": "https://coltec-global.com/#localbusiness",
                    name: "COLTEC Global",
                    url: "https://coltec-global.com",
                    image:
                      "https://content.qeeb.in/coltec/coltec-logo-black.svg",
                    address: {
                      "@type": "PostalAddress",
                      streetAddress:
                        "37, Survey No 75/A, Gagan Pahad Village, Raghavendra Nagar",
                      addressLocality: "Hyderabad",
                      addressRegion: "Telangana",
                      postalCode: "500030",
                      addressCountry: "IN",
                    },
                    telephone: "+91 1800 309 8822",
                    openingHours: "Mon-Sat 09:00-6:00",
                    geo: {
                      "@type": "GeoCoordinates",
                      latitude: "17.3297791",
                      longitude: "78.4381149",
                    },
                    sameAs: [
                      "https://www.facebook.com/profile.php?id=61570213181020",
                      "https://x.com/ColtecGlobal",
                      "https://www.linkedin.com/company/coltec-global/",
                      "https://www.youtube.com/@coltecglobal5339",
                      "https://www.google.com/maps/place/COLTEC+GLOBAL+INDIA/@17.3297791,78.4381149,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcbbd8bb97fefcd:0x2536a4697f2f1423!8m2!3d17.3297791!4d78.4406898!16s%2Fg%2F11w1dth9rd?entry=ttu&g_ep=EgoyMDI1MDIyNi4xIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D",
                    ],
                  },
                  // Media Image Gallery from expoData
                  imageGallery,
                ],
              },
              null,
              2
            )}
          </script>
        </Helmet>
        <Header />
        <div>
          <Banner
            imgSrc="https://content.qeeb.in/coltec/media/media-banner-image.webp"
            altText="Coltec Media Celebrating Moments of Excellence"
            bannerHeight="md:h-dvh h-[300px]"
            heading="Celebrating Moments of Excellence"
            headClasses="md:block hidden max-w-2xl text-[21px] font-semibold tracking-tight leading-[1.7] text-white sm:text-5xl drop-shadow-lg mt-3"
            opacityClasses="opacity-layer absolute inset-0 w-full h-full bg-neutral-liner z-0"
            paragraphText="Welcome to the Media page of COLTEC, where we showcase the milestones that define our journey. Explore a collection of moments from prestigious expos, awards, and events that reflect our commitment to innovation and excellence. Dive into the visual story of how COLTEC continues to shape the future of education and technology."
            positionClasses="absolute md:bottom-64 bottom-12 left-0 lg:left-32"
            headerTextClasses="text-[29px] md:text-4xl max-w-2xl text-white font-medium leading-10"
            paragraphTextClasses="md:text-base md:block hidden text-sm text-white max-w-2xl mt-4"
          />
          <div className="md:hidden block px-6 pt-8 bg-white">
            <div className="bg-neutral-900/60 absolute bottom-[545px] left-0 right-0 px-5 py-4">
              <h2 className="relative">
                <span class="text-white text-base font-medium font-['Poppins'] leading-snug">
                  Celebrating Moments of Excellence
                </span>
              </h2>
            </div>
            <p className="max-w-[373px] relative justify-start text-black text-xs font-normal font-['Poppins'] leading-[20px]">
              Welcome to the Media page of COLTEC, where we showcase the
              milestones that define our journey. Explore a collection of
              moments from prestigious expos, awards, and events that reflect
              our commitment to innovation and excellence. Dive into the visual
              story of how COLTEC continues to shape the future of education and
              technology.
            </p>
          </div>
        </div>
      </div>

      <div className="px-6 lg:px-8 lg:py-14 py-8 max-w-7xl m-auto relative md:space-y-16 space-y-8">
        {expoData.map((expo, index) => (
          <div key={index} className="md:text-center">
            <h2 className="text-[#383838] md:text-[36px] text-2xl font-normal text-center mb-4 md:mb-0">
              {expo.title}
            </h2>
            <p className="text-[#383838] md:text-base text-xs leading-5 font-normal max-w-3xl mx-auto mb-4 md:mb-10">
              {expo.description}
            </p>
            <div className="grid md:grid-cols-5 md:gap-6 gap-3">
              {expo.images.map((image, index) => (
                <div key={index} className={image.class}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full object-cover h-full"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Footer />
      <ScrollToTopButton />
      <WhatsAppMsg />
    </>
  );
};

export default Media;
